import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-volume',
	templateUrl: './icon-volume.component.svg',
})
export class IconVolumeComponent {}
